import React from 'react'
import '../../scss/variables.scss'
import '../../scss/reset.scss'
import './Subject.scss'
import NavbarArrow from '../../components/NavbarArrow/NavbarArrow'
import Footer from '../../components/Footer/Footer'
import Sidemenu from '../../components/Sidemenu/Sidemenu'

import swal from '@sweetalert/with-react';

class Others extends React.Component { 
    componentDidMount() {
      if(window.screen.width <= 900) {
        swal(
          <div className="mainContainerSwal">
            <p>Se sei da mobile PREMI su:</p>
              <div className="swalContainer">
                <div className="buttonJitsi">
                  <p>Avvia sul web</p>
                </div>
              </div>
          </div>,
          {
            buttons: false,
            timer: 3000
          }
        )
      }
    }

    render() {
     let arrowPath = "/stanze";
      return (
        <>
            <Sidemenu path1="/chi-siamo" name1="Chi Siamo" path2="/progetto" name2="Il Progetto" path3="/supportaci" name3="Supportaci" path4="/community" name4="Community"/>
            <NavbarArrow arrowPath={arrowPath} />
            <main className="subjectSection">
                <h1>Altro</h1>
                <div className="meetContainer">
                    <iframe src="https://meet.jit.si/Fady-Altro" title="meet" frameBorder="0" allow="microphone; camera"></iframe>
                </div>
            </main>
            {/* ADSENSE ads */}
            <div className="ad" align="center">
                <script async src="https://pagead2.googlesyndication.com/pagead/js/adsbygoogle.js?client=ca-pub-3763146420917084"
                crossOrigin="anonymous"></script>
            </div>
            <Footer />
        </>

      );
    }
  
  }

export default Others
